import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: ({ isSmall }) => (isSmall ? 'space-between' : 'center')
  },

  text: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    cursor: 'pointer',
    userSelect: 'none',

    '& > svg': {
      fontSize: theme.size.lg
    }
  },

  disabled: {
    cursor: 'default',
    opacity: '0.35'
  },

  page: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 2px',
    border: '1px solid transparent',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '18px',
    height: '16px',
    backgroundColor: 'transparent',
    fontSize: ({ isSmall }) => (isSmall ? theme.size.sm : 'inherit'),
    color: theme.palette.primary.main,
    cursor: 'pointer',
    userSelect: 'none'
  },

  pageActive: {
    borderColor: '#E6EAEC',
    backgroundColor: '#F7F8F9',
    color: '#323436',
    cursor: 'default'
  }
}))

export const useInfiniteLoaderStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '2rem'
  },

  text: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',
    cursor: 'pointer',
    userSelect: 'none',
    background: 'transparent',
    border: 'transparent'
  },

  disabled: {
    opacity: '0.35',
    cursor: 'not-allowed'
  },
  spinner: {
    zIndex: 2,
    top: 0,
    left: 'inherit'
  }
}))

export default useStyles
